import { Component } from '@angular/core';

@Component({
    selector: 'app-ask-ayen-groups',
    templateUrl: './groups-section.component.html',
    styleUrl: './groups-section.component.scss',
    standalone: false
})
export class GroupsSectionComponent {
  groups: { name: string; membersCount: number; questionsCount: number; isActive: boolean }[] = [];
}
